import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ApiRequestService } from '@core/auth/api-request.service';
import { config } from '@core/interfaces/api_baseurl';
import { Subject, Observable, BehaviorSubject, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  hostname: string = this.document.location.hostname;
  domainName: string = environment.domainName as string;
  // domainName: string = this.hostname === 'localhost' ? (environment.production ? 'nexgen.sprintnxt.in' : 'uat.sprintnxt.in') : this.hostname;
  domainKey: string = btoa(this.domainName);

  private sharedData: Subject<any> = new Subject<any>();
  sharedData$: Observable<any> = this.sharedData.asObservable();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private _ApiRequestService: ApiRequestService,
  ) { }

  topPanel(formdata: FormData) {
    return this._ApiRequestService.postData(config.sidemenu.topPanel, formdata);
  }
}